import React, {useState, useEffect, useContext} from 'react'
import axios from 'axios'
import {UserContext} from "../UserContext";
import TripModal from "../TripModal";
import UnitedStatesMap from "./UnitedStatesMap";
import nationalParksLogo from "../images/national parks logo.png";
import usFlag from "../images/united-states.png"
import {fiftyStates} from "../utils/50-states-boundaries";
import NationalParksMap from "./NationalParksMap";
import {getBearerToken, getServerUrl, nationalParksString} from "../utils/utils";
import {nationalParks} from "../utils/NationalParksUtils";
import NationalParkModal from "./NationalParkModal";
import bigBendLogo from "../images/big-bend.png"
import NationalParksMapTwo from "./NationalParksMapTwo";
import {useParams} from "react-router-dom";

function NationalParksMapContainerFour() {
    const {id} = useParams()
    const {user} = useContext(UserContext)
    const [trips, setTrips] = useState([])
    const [selectedNationalPark, setSelectedNationalPark] = useState(null)
    const [selectedNationalParkObj, setSelectedNationalParkObj] = useState(null)
    const [hoveredHikingTrailBox, setHoveredHikingTrailBox] = useState(null)

    const fetchTrips = async () => {
        axios.get(`${getServerUrl()}/user/${id || user?.id}/trip`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setTrips(response.data)
            })
    }

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    // const loadNationalParkBoundaries = async () => {
    //     const nationalParks = data.features.filter(feature => feature?.properties?.UNIT_NAME?.includes("National Park"))
    //     console.log("num national parks: " + nationalParks.length)
    //     for (let i =0; i < nationalParks.length; i++) {
    //         console.log(nationalParks[i]?.properties?.UNIT_NAME)
    //     }
    //
    //     for (let i =0; i<nationalParks.length; i++) {
    //         const feature = nationalParks[i]
    //         axios.post(`${getServerUrl()}/nationalPark/${feature?.properties?.UNIT_NAME}`, {
    //             boundary: JSON.stringify({
    //                 "crs": {
    //                     "type": "name",
    //                     "properties": {
    //                         "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
    //                     }
    //                 },
    //                 "name": "Public_Trails_dd_nad",
    //                 "type": "FeatureCollection",
    //                 "features": [feature]
    //             }),
    //         }, {})
    //             .then(res => {
    //             })
    //         await sleep(500); // Pause for 1 second
    //     }
    // }

    // const loadNationalParkTrails = async () => {
    //     for (let i =0; i < nationalParks.length; i++) {
    //         const nationalPark = nationalParks[i]
    //         console.log(nationalPark.name)
    //         const trails = data.features.filter(feature => feature?.properties?.UNITNAME?.includes(nationalPark.name))
    //         console.log("num trails at " + nationalPark.name + ": " + trails.length)
    //         axios.post(`${getServerUrl()}/nationalPark/${nationalPark.name}`, {
    //             trails: JSON.stringify({
    //                 "crs": {
    //                     "type": "name",
    //                     "properties": {
    //                         "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
    //                     }
    //                 },
    //                 "name": "Public_Trails_dd_nad",
    //                 "type": "FeatureCollection",
    //                 "features": trails
    //             }),
    //         }, {})
    //             .then(res => {
    //
    //             })
    //         await sleep(1000); // Pause for 1 second
    //     }


        // for (let i =0; i < nationalParks.length; i++) {
        //     console.log(nationalParks[i]?.properties?.UNIT_NAME)
        // }
    // }

    useEffect(() => {
        if (user?.id) {
            fetchTrips()
            // data.features.forEach(feature => {
            //     console.log(feature)
            //     }
            // )
            // loadNationalParkTrails()
            // loadNationalParkBoundaries()


        }
    }, [user])

    const getNumNationalParksVisited = () => {
        let numNationalParksVisited = 0;
        for (let i = 0; i < nationalParks.length; i++) {
            const nationalParkName = nationalParks[i].name
            for (let j = 0; j < trips.length; j++) {
                const trip = trips[j]
                if (trip.categoryItem === nationalParkName ||
                    trip.activities?.some(activity => activity.categoryItem === nationalParkName)) {
                    numNationalParksVisited++;
                    j = trips.length;
                }
            }
        }
        return numNationalParksVisited
    }

    const displayNationalParksList = (start, finish) => {
        return nationalParks.slice(start, finish).map((nationalPark, index) => {
            const numParkVisits = trips.filter(trip => trip.categoryItem === nationalPark.name).length
            const hasVisitedPark = numParkVisits > 0
            // return (
            //     <div
            //         className={`individual-state-container ${hasVisitedPark ? "" : "not-visited"}`}
            //         id="national-parks-container"
            //         onClick={() => setSelectedNationalPark(nationalPark.name)}
            //     >
            //         {/*<img src={state.logo}/>*/}
            //         <strong>{`${nationalPark.name}`}</strong>
            //         <div
            //             className={`num-visited-container ${hasVisitedPark ? "visitedPark" : ""}`}>{isLeft ? (index + 1) : (index + 32 + 1)}</div>
            //     </div>
            // )
            return (
                <div
                    className={`individual-state-container ${hasVisitedPark ? "" : "not-visited"}`}
                    onClick={() => setSelectedNationalPark(nationalPark.name)}
                >
                    {/*<img src={state.logo}/>*/}
                    {/*<strong>{`${nationalPark.name}`}</strong>*/}
                    <div
                        className={`${hasVisitedPark ? "visitedPark" : ""}`}>
                        {/*{isLeft ? (index + 1) : (index + 32 + 1)}*/}
                        <img className={hasVisitedPark ? "" : "not-visited-park"} src={nationalPark.logo || bigBendLogo} />
                    </div>
                </div>
            )
        })
    }


    return (
        <div style={{width: "100%", height: "calc(100vh - 66px)", position: "relative"}}
             id="national-parks-map-container-images">
            <NationalParksMapTwo
                trips={trips}
                selectedNationalPark={selectedNationalPark}
                setSelectedNationalPark={nationalParkName => setSelectedNationalPark(nationalParkName)}
                hoveredHikingTrailBox={hoveredHikingTrailBox}
                zoom={4.2}
                center={[-97.2, 37.7]}
                selectedNationalParkObj={selectedNationalParkObj}
                setSelectedNationalParkObj={newSelectedNationalParkObj => setSelectedNationalParkObj(newSelectedNationalParkObj)}
            />
            {!selectedNationalPark && (
            <div className="national-park-progress-container">
                <img src={nationalParksLogo}/>
                <div className="teams-visited-summary">
                    <div style={{color: "#213A1B"}}>{`${getNumNationalParksVisited()} national parks visited`}</div>
                    <div style={{color: "#C56C39"}}> {`${63 - getNumNationalParksVisited()} national parks remaining`}</div>
                </div>
            </div>
            )}

            {selectedNationalPark && (
                <NationalParkModal selectedNationalPark={selectedNationalPark} selectedNationalParkObj={selectedNationalParkObj} trips={trips} onHoverHikingTrailBox={trail => setHoveredHikingTrailBox(trail)}/>
            )}
        </div>
    )
}

export default NationalParksMapContainerFour;

